import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

import Header, {
  NavLink,
  NavLinks,
  PrimaryLink as PrimaryLinkBase,
  LogoLink,
  NavToggle,
  DesktopNavLinks
} from "../headers/light.js";

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none w-full`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-white hover:border-gray-300 hover:text-gray-300`}
    font-family: 'Orbitron', sans-serif;
  }
  ${NavToggle}.closed {
    ${tw`text-white hover:text-primary-500`}
  }
`;

const PrimaryLink = tw(PrimaryLinkBase)`rounded-full bg-red-500 text-white hocus:bg-red-700 hocus:text-gray-200`;

const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover h-screen min-h-144`}
  background-image: url("/fotodj/rafaposando.webp");
`;

const InfoContainer = styled.div`
  ${tw`p-6 text-gray-100 rounded-lg shadow-lg w-full max-w-lg mt-8`}
  background-color: #0a1a2f;
  z-index: 20;
`;

const SliderContainer = styled.div`
  ${tw`overflow-hidden`}
  .slick-dots {
    ${tw`bottom-0`}
  }
  .slick-dots li button:before {
    color: white;
  }
  .slick-dots li.slick-active button:before {
    color: yellow;
  }
`;

const InfoText = styled.p`
  ${tw`mb-4 text-center`}
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-black opacity-75`;
const HeroContainer = tw.div`z-20 relative px-6 sm:px-8 mx-auto h-full flex flex-col`;
const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`;

const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-4xl lg:text-5xl xl:text-6xl font-black text-white leading-snug -mt-24 sm:mt-0`}
  font-family: 'Orbitron', sans-serif;
  span {
    ${tw`inline-block mt-2`}
  }
`;

export default () => {
  const { t } = useTranslation();

  const handleNavClick = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navLinks = [
    <NavLinks key={1}>
      <NavLink onClick={() => handleNavClick("inicio")}>{t("header.fotos")}</NavLink>
      <NavLink onClick={() => handleNavClick("blog")}>{t("header.videos")}</NavLink>
      <NavLink onClick={() => handleNavClick("sets")}>{t("header.sets")}</NavLink>
      <NavLink onClick={() => handleNavClick("contacto")}>{t("header.contacto")}</NavLink>
    </NavLinks>,
    <NavLinks key={2}></NavLinks>
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000
  };

  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <StyledHeader links={navLinks} />
        <Content>
          <Heading>{t("hero.heading")}</Heading>
          <InfoContainer>
            <SliderContainer>
              <Slider {...sliderSettings}>
                {t("hero.info", { returnObjects: true }).map((text, index) => (
                  <div key={index}>
                    <InfoText>{text}</InfoText>
                  </div>
                ))}
              </Slider>
            </SliderContainer>
          </InfoContainer>
        </Content>
      </HeroContainer>
    </Container>
  );
};
